import { useDeletePricingMutation } from "@sso/apis/pricing";
import { useGetPricingById } from "@sso/apis/pricing/hooks";
import { DialogTitle } from "@sso/constant";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectDialog } from "@sso/store/slices/dialog";
import { Typography } from "@sso/ui/Typography";

import { DialogActionButtons, DialogBody, DialogHeader } from "../components";

export const DeletePricingDialog = () => {
  const { id } = useAppSelector(selectDialog);
  const pri = useGetPricingById(id?.toString());

  const [deletePricing, { isLoading }] = useDeletePricingMutation();

  const handleDeleteAction = () => {
    if (!id || !pri) {
      return;
    }
    deletePricing(id.toString());
  };

  return (
    <>
      <DialogHeader title={DialogTitle.DELETE_PRICING} />
      <DialogBody>
        <Typography display="initial">
          Are you sure to delete this Pricing?
          <br />
        </Typography>
      </DialogBody>
      <DialogActionButtons loading={isLoading} buttonTitle={"Delete"} onClickAction={handleDeleteAction} />
    </>
  );
};
